<ng-container *ngIf="!isLoadingView; else tplNoData">
  <ng-container *ngIf="canDisplayGrille(); else tplNoRepas">

    <div id="accordion">
      <dx-accordion
        [dataSource]="repas"
        [collapsible]="true"
        [multiple]="true"
        [animationDuration]="300"
        [selectedItems]="repas"
      >
        <div *dxTemplate="let item of 'title'">
          <h6>{{ item.repas.libelle }}</h6>
        </div>
        <div *dxTemplate="let item of 'item'">
          <yo-generic-repas-plc
            [prestations]="item.prestations" [cols]="cols" [repas]="item.repas"
            [datesDetailsFromMenu]="datesDetailsFromMenu" [configPortailPlc]="configPortailPlc">
          </yo-generic-repas-plc>
        </div>
      </dx-accordion>
    </div>

  </ng-container>
</ng-container>

<ng-template #tplNoRepas>
  <div class="mt-4 mb-4">
    <i class="mg-r-5 fas fa-exclamation-triangle danger-color"></i>Aucun menu existant pour cette période.
  </div>
</ng-template>

<ng-template #tplNoData>
  <div class="indicators">
    <dx-load-indicator
      id="large-indicator"
      height="60"
      width="60"
    ></dx-load-indicator>
  </div>
</ng-template>
